module.exports = __webpack_public_path__ + "img/screenshot002.217f546e.png";